"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.setupBillEndpoints = void 0;
var utils_1 = require("../utils");
var getBasePath = (0, utils_1.getBasePathFactory)('/bill');
function setupBillEndpoints(api) {
    return api.injectEndpoints({
        endpoints: function (build) { return ({
            getCancelBillEligibility: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/cancel/eligibility");
                }
            }),
            cancelBill: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/cancel"),
                        method: 'POST'
                    });
                }
            }),
            selfPayConfirmPayment: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/selfpay/confirm-payment"),
                        method: 'POST'
                    });
                }
            }),
            getDdaDetails: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/selfpay/dda");
                }
            }),
            getBillAmount: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return getBasePath(customerId);
                }
            }),
            getRentBillDetails: build.query({
                query: function (_a) {
                    var customerId = _a.customerId, queryDate = _a.queryDate;
                    return ({
                        url: "".concat(getBasePath(customerId), "/rent/details/").concat(queryDate),
                        keepUnusedDataFor: 2
                    });
                }
            }),
            billPayNow: build.mutation({
                query: function (_a) {
                    var amount_cent = _a.amount_cent, customerId = _a.customerId, source = _a.source;
                    return ({
                        url: "".concat(getBasePath(customerId), "/pay-now"),
                        method: 'POST',
                        body: __assign({ amount_cent: amount_cent }, (source && { source: source }))
                    });
                }
            }),
            billPayNowSubmit: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/pay-now/submit"),
                        method: 'POST'
                    });
                }
            }),
            getBillStatus: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/status");
                }
            }),
            getPayNowEligibility: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/pay-now/eligibility");
                }
            }),
            embedPayNowEligibility: build.query({
                query: function (_a) {
                    var client = _a.client, customerId = _a.customerId, token = _a.token;
                    return "".concat(getBasePath(customerId), "/pay-now/embed/eligibility?token=").concat(token, "&client=").concat(client);
                }
            }),
            getRescheduleDownpaymentOptions: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return "".concat(getBasePath(customerId), "/downpayment/reschedule-options");
                }
            }),
            rescheduleDownpayment: build.mutation({
                query: function (_a) {
                    var customerId = _a.customerId, date = _a.date;
                    return ({
                        url: "".concat(getBasePath(customerId), "/downpayment/reschedule"),
                        method: 'POST',
                        body: { date: date }
                    });
                }
            }),
            getBillPayConfiguration: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/bill-pay-configuration"),
                        method: 'GET'
                    });
                }
            }),
            getRentAmountSurveyOptions: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/survey/rent_amount_update"),
                        method: 'GET'
                    });
                }
            }),
            getCutoffDates: build.query({
                query: function (_a) {
                    var customerId = _a.customerId;
                    return ({
                        url: "".concat(getBasePath(customerId), "/cutoffs"),
                        method: 'GET'
                    });
                }
            })
        }); }
    });
}
exports.setupBillEndpoints = setupBillEndpoints;
